<template>
  <div
    class="wallet-workpackage-body"
    :style="getHeight()"
    >
    <slot/>
    <div class="wallet-workpackage-button-top self-centered">
      <slot name="button-top"/>
    </div>
    <div class="wallet-workpackage-button-right self-centered">
      <slot name="button-right"/>
    </div>
    <div class="wallet-workpackage-button-bottom self-centered">
      <slot name="button-bottom"/>
    </div>
    <div class="wallet-workpackage-button-left self-centered">
      <slot name="button-left"/>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    getHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return `height: calc(${window.innerHeight}px - 150px);`
      } else {
        return `height: calc(100vh - 225px);`
      }
    }
  }
}
</script>
<style>
  .wallet-workpackage-body {
    position: relative;
    width: 100%;
    height: calc(100vh - 225px);
    overflow: visible;
    /* border: solid 1px white */
  }
  .wallet-workpackage-button-top {
    position: absolute;
    top: 12px;
    left: 50%;
    background-color: red;
  }
  .wallet-workpackage-button-right {
    position: absolute;
    top: 45%;
    left: calc(100% - 12px);
  }
  .wallet-workpackage-button-bottom {
    position: absolute;
    top: calc(100% - 12px);
    left: 50%;
    background-color: red;

  }
  .wallet-workpackage-button-left {
    position: absolute;
    top: 45%;
    left: 12px;
  }
</style>
